<template>
  <venue-form
    :formKey="editFormKey"
    :action="`/admin/venues/${venueId}`"
    :venueId="venueId"
    method="patch"
    @formValid="val => (formValid = val)"
    :additional-data="{ ...primaryUser }"
    :venue-data="venue"
    @submitSuccess="onEditFormSubmit"
  >
    <template #primaryContact>
      <div>
        <primary-contact-dropdown
          :primary-selected="primarySelectedUser"
          :options="users"
          class="mt-12"
          label="Primary Contact"
          name="primaryUserId"
          :form-key="editFormKey"
          @onSelect="primaryContactChanged"
        />
        <div class="contact-info mt-8">
          <p class="contact-info__txt">
            User needs to have a phone number in order to be able to be set as a primary contact.
          </p>
        </div>
      </div>
    </template>
    <template #buttons>
      <ez-button form-type="submit">Save Changes</ez-button>
    </template>
  </venue-form>
</template>

<script>
import { mapActions } from 'vuex';
import EzButton from '@/components/ui/Button';
import flash from '@/components/ui/FlashMessage';
import PrimaryContactDropdown from '@/views/common/users/PrimaryContactDropdown';
import VenueForm from '@/views/admin/venues/FormAdmin.vue';

export default {
  components: {
    EzButton,
    PrimaryContactDropdown,
    VenueForm,
  },
  props: {
    venueId: {
      type: Number,
      required: true,
    },
    groupId: {
      type: Number,
      required: true,
    },
    entity: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      formValid: false,
      editFormKey: 'edit-venue',
      users: [],
      primaryUser: {
        primaryUserId: '',
      },
    };
  },
  computed: {
    venue() {
      return this.entity;
    },
    primarySelectedId() {
      return this.venue?.primaryUserId;
    },
    primarySelectedUser() {
      return this.users.find(user => user.id === this.primarySelectedId) || {};
    },
  },
  methods: {
    ...mapActions('entities/users', ['adminFetchUsers']),
    ...mapActions('entities/venues', ['fetchVenue']),
    async onEditFormSubmit() {
      flash.success({ title: `${this.$t('global.venue')} successfully updated!` });
      await this.fetchVenue(this.venue.id);
    },
    primaryContactChanged(ev) {
      this.primaryUser.primaryUserId = ev.id;
    },
  },
  async created() {
    const { data } = await this.adminFetchUsers({ groupId: this.groupId });
    this.users = [{ id: null, name: 'Unassigned' }, ...data.data];
  },
};
</script>

<style scoped lang="scss">
.venue-form {
  .button {
    margin-top: 1.5rem;
  }
}
.contact-info {
  &__txt {
    @include font-size(12px);
    color: $color-gray-6C;
    margin: 0;
    line-height: px-to-rem(18px);
  }
}
</style>
